import axios from 'axios';

// Success messages for different operations
const successMessages = {
  POST: 'Created successfully!',
  PUT: 'Updated successfully!',
  PATCH: 'Updated successfully!',
  DELETE: 'Deleted successfully!'
};

// Create event for toast notifications
export const showSuccessToast = (message) => {
  window.dispatchEvent(new CustomEvent('showToast', {
    detail: { message, type: 'success' }
  }));
};

export const showErrorToast = (message) => {
  window.dispatchEvent(new CustomEvent('showToast', {
    detail: { message, type: 'error' }
  }));
};

// Setup axios interceptor
export const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => {
      const method = response.config.method?.toUpperCase();
      
      // Show success toast for POST, PUT, PATCH, DELETE
      if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
        const message = successMessages[method];
        showSuccessToast(message);
      }
      
      return response;
    },
    (error) => {
      // Show error toast
      const message = error.response?.data?.error || error.response?.data?.msg || 'Something went wrong!';
      showErrorToast(message);
      return Promise.reject(error);
    }
  );
};
